import { StopFollowUpConfirmModal } from '../../components/StopFollowUpConfirmModal';
import { ActionConfirmModal } from '../../components/ActionConfirmModal';
import { RescheduleModal } from '../../crm/components/RescheduleModal';
import { formatDateTimeOffset } from '../utils';

export function ReminderActionModals({
  actionPopup,
  onClose,
  stop,
  pause,
  resume,
  reschedule,
  isStopping,
  isPausing,
  isResuming,
  isRescheduling,
}) {
  const reminder = actionPopup?.reminder;
  const type = actionPopup?.type;
  const busy = isStopping || isPausing || isResuming || isRescheduling;

  const closeIfIdle = () => {
    if (!busy) onClose();
  };

  const confirm = (run) => {
    if (!reminder) return;
    onClose();
    run();
  };

  return (
    <>
      <StopFollowUpConfirmModal
        isOpen={type === 'stop'}
        onCancel={closeIfIdle}
        onConfirm={() => confirm(() => stop(reminder))}
        isPending={isStopping}
        title="Stop Reminder"
        entityLabel="Reminder"
        description="This reminder will not send."
      />

      <ActionConfirmModal
        isOpen={type === 'pause'}
        onCancel={closeIfIdle}
        onConfirm={() => confirm(() => pause(reminder))}
        isPending={isPausing}
        title="Pause Reminder"
        description="Recurring reminder will pause."
        confirmLabel="Pause"
        pendingLabel="Pausing..."
      />

      <ActionConfirmModal
        isOpen={type === 'resume'}
        onCancel={closeIfIdle}
        onConfirm={() => confirm(() => resume(reminder))}
        isPending={isResuming}
        title="Resume Reminder"
        description="Next send will be now plus the interval, not the previous scheduled time."
        confirmLabel="Resume"
        pendingLabel="Resuming..."
      />

      <RescheduleModal
        isOpen={type === 'reschedule'}
        onClose={closeIfIdle}
        isRescheduling={isRescheduling}
        title="Reschedule Reminder"
        description="Select a new date and time for this reminder."
        serializeDateTime={formatDateTimeOffset}
        onReschedule={(newDateTime) =>
          confirm(() => reschedule({ reminder, newDateTime }))
        }
      />
    </>
  );
}
